/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { GameLeaderboardDto } from '../models';
import { TournamentLeaderboardDto } from '../models';
/**
 * LeaderboardApi - axios parameter creator
 * @export
 */
export const LeaderboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Redeems leaderboard rewards for the top N players in a game aggregate leaderboard
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardAwardAggregateGet: async (tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/award/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redeems leaderboard rewards for the top N players in a game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [tournamentId] Optional tournament ID
         * @param {string} [server] The server name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardAwardGameGet: async (gameContextId?: string, tournamentId?: string, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/award/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (gameContextId !== undefined) {
                localVarQueryParameter['gameContextId'] = gameContextId;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually triggers tournament leaderboard award distribution via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
         * @param {string} [tournamentId] Tournament ID (REQUIRED)
         * @param {string} [server] The server name
         * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardAwardTournamentPost: async (tournamentId?: string, server?: string, force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/award/tournament`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculates or recalculates the aggregate leaderboard based on date range
         * @param {string} [server] The server name
         * @param {string} [tournamentId] required
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardCalculateAggregateGet: async (server?: string, tournamentId?: string, startDate?: Date, endDate?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/calculate/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculates or recalculates the game leaderboard for a specific game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [tournamentId] Optional tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardCalculateGameGet: async (gameContextId?: string, tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/calculate/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (gameContextId !== undefined) {
                localVarQueryParameter['gameContextId'] = gameContextId;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually triggers tournament leaderboard calculation via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
         * @param {string} [tournamentId] Tournament ID (REQUIRED)
         * @param {string} [server] The server name
         * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardCalculateTournamentPost: async (tournamentId?: string, server?: string, force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/calculate/tournament`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given entry from the GameLeaderboards database, given the entry id
         * @param {string} [server] Server to delete the entry from
         * @param {string} [id] Id of the entry to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardEntryDelete: async (server?: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/entry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get leaderboard entries for a specific aggregate leaderboard
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardListAggregateGet: async (tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/list/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get leaderboard entries for a specific game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardListGameGet: async (gameContextId?: string, server?: string, startDate?: Date, endDate?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/list/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (gameContextId !== undefined) {
                localVarQueryParameter['gameContextId'] = gameContextId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get leaderboard entries for a tournament, grouped by game context.  This endpoint replaces the deprecated aggregate leaderboard endpoint.  Leaderboards are computed based on tournament and game context, similar to LeaderboardCalculationController.
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeaderboardListTournamentGet: async (tournamentId?: string, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Leaderboard/list/tournament`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeaderboardApi - functional programming interface
 * @export
 */
export const LeaderboardApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Redeems leaderboard rewards for the top N players in a game aggregate leaderboard
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardAwardAggregateGet(tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardAwardAggregateGet(tournamentId, server, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Redeems leaderboard rewards for the top N players in a game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [tournamentId] Optional tournament ID
         * @param {string} [server] The server name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardAwardGameGet(gameContextId?: string, tournamentId?: string, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardAwardGameGet(gameContextId, tournamentId, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Manually triggers tournament leaderboard award distribution via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
         * @param {string} [tournamentId] Tournament ID (REQUIRED)
         * @param {string} [server] The server name
         * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardAwardTournamentPost(tournamentId?: string, server?: string, force?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardAwardTournamentPost(tournamentId, server, force, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Calculates or recalculates the aggregate leaderboard based on date range
         * @param {string} [server] The server name
         * @param {string} [tournamentId] required
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardCalculateAggregateGet(server?: string, tournamentId?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardCalculateAggregateGet(server, tournamentId, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Calculates or recalculates the game leaderboard for a specific game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [tournamentId] Optional tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardCalculateGameGet(gameContextId?: string, tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardCalculateGameGet(gameContextId, tournamentId, server, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Manually triggers tournament leaderboard calculation via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
         * @param {string} [tournamentId] Tournament ID (REQUIRED)
         * @param {string} [server] The server name
         * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardCalculateTournamentPost(tournamentId?: string, server?: string, force?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardCalculateTournamentPost(tournamentId, server, force, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a given entry from the GameLeaderboards database, given the entry id
         * @param {string} [server] Server to delete the entry from
         * @param {string} [id] Id of the entry to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardEntryDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardEntryDelete(server, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get leaderboard entries for a specific aggregate leaderboard
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardListAggregateGet(tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<GameLeaderboardDto>>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardListAggregateGet(tournamentId, server, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get leaderboard entries for a specific game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardListGameGet(gameContextId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<GameLeaderboardDto>>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardListGameGet(gameContextId, server, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get leaderboard entries for a tournament, grouped by game context.  This endpoint replaces the deprecated aggregate leaderboard endpoint.  Leaderboards are computed based on tournament and game context, similar to LeaderboardCalculationController.
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardListTournamentGet(tournamentId?: string, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<TournamentLeaderboardDto>>> {
            const localVarAxiosArgs = await LeaderboardApiAxiosParamCreator(configuration).apiLeaderboardListTournamentGet(tournamentId, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LeaderboardApi - factory interface
 * @export
 */
export const LeaderboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Redeems leaderboard rewards for the top N players in a game aggregate leaderboard
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardAwardAggregateGet(tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LeaderboardApiFp(configuration).apiLeaderboardAwardAggregateGet(tournamentId, server, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redeems leaderboard rewards for the top N players in a game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [tournamentId] Optional tournament ID
         * @param {string} [server] The server name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardAwardGameGet(gameContextId?: string, tournamentId?: string, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LeaderboardApiFp(configuration).apiLeaderboardAwardGameGet(gameContextId, tournamentId, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually triggers tournament leaderboard award distribution via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
         * @param {string} [tournamentId] Tournament ID (REQUIRED)
         * @param {string} [server] The server name
         * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardAwardTournamentPost(tournamentId?: string, server?: string, force?: boolean, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return LeaderboardApiFp(configuration).apiLeaderboardAwardTournamentPost(tournamentId, server, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculates or recalculates the aggregate leaderboard based on date range
         * @param {string} [server] The server name
         * @param {string} [tournamentId] required
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardCalculateAggregateGet(server?: string, tournamentId?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return LeaderboardApiFp(configuration).apiLeaderboardCalculateAggregateGet(server, tournamentId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculates or recalculates the game leaderboard for a specific game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [tournamentId] Optional tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardCalculateGameGet(gameContextId?: string, tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return LeaderboardApiFp(configuration).apiLeaderboardCalculateGameGet(gameContextId, tournamentId, server, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually triggers tournament leaderboard calculation via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
         * @param {string} [tournamentId] Tournament ID (REQUIRED)
         * @param {string} [server] The server name
         * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardCalculateTournamentPost(tournamentId?: string, server?: string, force?: boolean, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return LeaderboardApiFp(configuration).apiLeaderboardCalculateTournamentPost(tournamentId, server, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given entry from the GameLeaderboards database, given the entry id
         * @param {string} [server] Server to delete the entry from
         * @param {string} [id] Id of the entry to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardEntryDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LeaderboardApiFp(configuration).apiLeaderboardEntryDelete(server, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get leaderboard entries for a specific aggregate leaderboard
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardListAggregateGet(tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<GameLeaderboardDto>>> {
            return LeaderboardApiFp(configuration).apiLeaderboardListAggregateGet(tournamentId, server, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get leaderboard entries for a specific game
         * @param {string} [gameContextId] The game context ID
         * @param {string} [server] The server name
         * @param {Date} [startDate] Optional start date
         * @param {Date} [endDate] Optional end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardListGameGet(gameContextId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<GameLeaderboardDto>>> {
            return LeaderboardApiFp(configuration).apiLeaderboardListGameGet(gameContextId, server, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get leaderboard entries for a tournament, grouped by game context.  This endpoint replaces the deprecated aggregate leaderboard endpoint.  Leaderboards are computed based on tournament and game context, similar to LeaderboardCalculationController.
         * @param {string} [tournamentId] The tournament ID
         * @param {string} [server] The server name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeaderboardListTournamentGet(tournamentId?: string, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<TournamentLeaderboardDto>> {
            return LeaderboardApiFp(configuration).apiLeaderboardListTournamentGet(tournamentId, server, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeaderboardApi - object-oriented interface
 * @export
 * @class LeaderboardApi
 * @extends {BaseAPI}
 */
export class LeaderboardApi extends BaseAPI {
    /**
     * 
     * @summary Redeems leaderboard rewards for the top N players in a game aggregate leaderboard
     * @param {string} [tournamentId] The tournament ID
     * @param {string} [server] The server name
     * @param {Date} [startDate] Optional start date
     * @param {Date} [endDate] Optional end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardAwardAggregateGet(tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardAwardAggregateGet(tournamentId, server, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Redeems leaderboard rewards for the top N players in a game
     * @param {string} [gameContextId] The game context ID
     * @param {string} [tournamentId] Optional tournament ID
     * @param {string} [server] The server name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardAwardGameGet(gameContextId?: string, tournamentId?: string, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardAwardGameGet(gameContextId, tournamentId, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Manually triggers tournament leaderboard award distribution via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
     * @param {string} [tournamentId] Tournament ID (REQUIRED)
     * @param {string} [server] The server name
     * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardAwardTournamentPost(tournamentId?: string, server?: string, force?: boolean, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardAwardTournamentPost(tournamentId, server, force, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Calculates or recalculates the aggregate leaderboard based on date range
     * @param {string} [server] The server name
     * @param {string} [tournamentId] required
     * @param {Date} [startDate] Optional start date
     * @param {Date} [endDate] Optional end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardCalculateAggregateGet(server?: string, tournamentId?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardCalculateAggregateGet(server, tournamentId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Calculates or recalculates the game leaderboard for a specific game
     * @param {string} [gameContextId] The game context ID
     * @param {string} [tournamentId] Optional tournament ID
     * @param {string} [server] The server name
     * @param {Date} [startDate] Optional start date
     * @param {Date} [endDate] Optional end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardCalculateGameGet(gameContextId?: string, tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardCalculateGameGet(gameContextId, tournamentId, server, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Manually triggers tournament leaderboard calculation via Lambda invocation.  This endpoint invokes the CallApi Lambda function which calls the yvr.api LeaderboardCalculationController.
     * @param {string} [tournamentId] Tournament ID (REQUIRED)
     * @param {string} [server] The server name
     * @param {boolean} [force] If true, bypasses the 4-minute end date check. Use for admin manual triggers. Default: false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardCalculateTournamentPost(tournamentId?: string, server?: string, force?: boolean, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardCalculateTournamentPost(tournamentId, server, force, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Deletes a given entry from the GameLeaderboards database, given the entry id
     * @param {string} [server] Server to delete the entry from
     * @param {string} [id] Id of the entry to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardEntryDelete(server?: string, id?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardEntryDelete(server, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get leaderboard entries for a specific aggregate leaderboard
     * @param {string} [tournamentId] The tournament ID
     * @param {string} [server] The server name
     * @param {Date} [startDate] Optional start date
     * @param {Date} [endDate] Optional end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardListAggregateGet(tournamentId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<GameLeaderboardDto>>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardListAggregateGet(tournamentId, server, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get leaderboard entries for a specific game
     * @param {string} [gameContextId] The game context ID
     * @param {string} [server] The server name
     * @param {Date} [startDate] Optional start date
     * @param {Date} [endDate] Optional end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardListGameGet(gameContextId?: string, server?: string, startDate?: Date, endDate?: Date, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<GameLeaderboardDto>>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardListGameGet(gameContextId, server, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get leaderboard entries for a tournament, grouped by game context.  This endpoint replaces the deprecated aggregate leaderboard endpoint.  Leaderboards are computed based on tournament and game context, similar to LeaderboardCalculationController.
     * @param {string} [tournamentId] The tournament ID
     * @param {string} [server] The server name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardApi
     */
    public async apiLeaderboardListTournamentGet(tournamentId?: string, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<TournamentLeaderboardDto>> {
        return LeaderboardApiFp(this.configuration).apiLeaderboardListTournamentGet(tournamentId, server, options).then((request) => request(this.axios, this.basePath));
    }
}
